import * as L from 'leaflet';
import * as marked from 'marked';
import * as togpx from 'togpx';

class FreerideLines {
  map;
  featureGroup;
  constructor(map, featureGroup) {
    this.map = map;
    this.featureGroup = featureGroup;
  }

  exportGpx(id) {
    console.log('try to load ', id);
    let fn = 'track.gpx';
    let ret = '';
    this.featureGroup.eachLayer(l => {
      if (l._id === id) {
        console.log('got:  ', l);
        if (l.properties && l.properties.name) {
          fn = `${l.properties.name}.gpx`;
        }
        ret = togpx(l.toGeoJSON());
      }
    });
    if (ret) {
      const fileURL = window.URL.createObjectURL(new Blob([ret]));
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fn);
      document.body.appendChild(fileLink);
      fileLink.click();
    } else {
      alert('Not found');
    }
  }

  loadLines(opts = { showExport: false }) {
    fetch("/sh/freeride/lines")
      .then((d) => d.json())
      .then((d) => {
        for (let i = 0; i < d.length; i++) {
          const coords = [];
          for (var j = 0; j < d[i].geometry.coordinates.length; j++) {
            coords.push([
              d[i].geometry.coordinates[j][1],
              d[i].geometry.coordinates[j][0]
            ]);
          }
          var color = 'darkblue';
          var l = L.polyline(coords, {
            color: color
          });
          l.properties = d[i].properties;
          l._id = d[i]._id;
          const exp = document.createElement('button');
          exp.innerHTML = 'GPX export';
          const id = l._id;
          exp.onclick = () => { return this.exportGpx(id) };
          if (l.properties.name && l.properties.description) {
            const pop = new L.Popup({
              minWidth: 500,
              className: 'markedPopup'
            });
            const html = document.createElement('div');
            html.innerHTML = `<h4>${l.properties.name}</h4>
            <p>${marked(l.properties.description)}</p>
            `;
            if (opts.showExport) {
              html.append(exp);
            }
            pop.setContent(html);
            l.bindPopup(pop);
          } else {
            l.bindPopup(exp);
          }
          this.featureGroup.addLayer(l);
        }
      })
  }
}


const FreerideLineLayer = L.FeatureGroup.extend({
  onAdd: function (map) {
    const lines = new FreerideLines(map, this);
    lines.loadLines();
  },
});

export { FreerideLineLayer, FreerideLines }
